import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByClaimStatus'
})
export class FilterByClaimStatusPipe implements PipeTransform {
  transform(files: any[], isClaimFile?: boolean): any[] {
    if (isClaimFile === undefined) {
      return files;
    }
    return files.filter(file => file.isClaimFile === isClaimFile);
  }
} 